import {Button, Card, Stack, Typography, styled} from '@mui/material';

const StyledProviderName = styled(Typography)`
	color: ${({theme}) => theme.palette.primary.main};
	font-size: 1rem;
	font-weight: 600;
	line-height: 120%;
	letter-spacing: 0.15px;
`;

const StyledTitleWithQualifications = styled(Typography)`
	color: ${({theme}) => theme.palette.primary.main};
	font-weight: 600;
	line-height: 1.2;
	letter-spacing: 0.15px;
`;

const StyledQualificationsContainer = styled(Stack)`
	gap: 8px;
`;

const StyledAddressStack = styled(Stack)`
	gap: 16px;
	margin-bottom: 16px;
`;

const StyledOptionsContainer = styled(Stack)`
	justify-content: end;
	flex-direction: row;
	gap: 8px;
	height: inherit;
`;

const StyledSmallButton = styled(Button)`
	align-self: flex-end;
	margin-top: auto;
	text-transform: none;
	padding: 4px 10px;
	.MuiButton-endIcon {
		margin-left: 4px;
	}
`;

const StyledCard = styled(Card)`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

export {
	StyledProviderName,
	StyledTitleWithQualifications,
	StyledQualificationsContainer,
	StyledAddressStack,
	StyledOptionsContainer,
	StyledSmallButton,
	StyledCard,
};
